// extracted by mini-css-extract-plugin
export default {"root":"NervousSystem_root__VjaAD","bubbleRoot":"NervousSystem_bubbleRoot__E0aQw","bubble":"NervousSystem_bubble__dCzqf","pilot":"NervousSystem_pilot__Zs93s"};